import { Component, OnInit } from '@angular/core';
import {GoBaseComponent} from "../go-base.component";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {VALUE_TYPE} from "../../../enums/enums";

@Component({
  selector: 'app-go-orders',
  templateUrl: './go-orders.component.html',
  styles: []
})
export class GoOrdersComponent extends GoBaseComponent {

  GO_COMPONENTS = GO_COMPONENTS;
  VALUE_TYPE = VALUE_TYPE;

  constructor() {
    super(GO_COMPONENTS.ORDERS);
  }


}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-orders/go-orders.component.ts